import React from 'react';
import { Button, Content, ContentVariants, PageSection, Title } from '@patternfly/react-core';
import { TimesIcon } from '@patternfly/react-icons';
import { TimeLogHistory } from '../components/TimeLogHistory';
import { usePageHeaderVisibility } from '../hooks';
import './WorkLog.css';

const WorkLog: React.FC = () => {
  const { isHeaderVisible, hideHeader } = usePageHeaderVisibility('worklog');

  return (
    <PageSection hasBodyWrapper={false}>
      {isHeaderVisible && (
        <div className="worklog-header">
          <div className="page-header__title-row">
            <Title headingLevel="h1" size="2xl">
              Work log
            </Title>
            <Button
              variant="plain"
              aria-label="Hide header"
              onClick={hideHeader}
              className="page-header__close-btn"
            >
              <TimesIcon />
            </Button>
          </div>
          <Content component={ContentVariants.p} className="worklog-description">
            View and manage your past work logs. Select a date to see what you worked on.
          </Content>
        </div>
      )}
      <TimeLogHistory />
    </PageSection>
  );
};

export { WorkLog };
